export default __webpack_public_path__ + "static/media/PY.2d9cb82c.svg";